<template>
  <div>
    <div class="p-24 header-top">
      <router-link to="/layout/registration" class="d-flex">
        <img src="/static/images/icons/emergo_right_chevron.svg" alt="" />
        <div class="fw-400 certificate-heading primary-default-text-color">
          {{ $t('addCertificate') }}
        </div>
      </router-link>
    </div>
    <div class="certificate-content">
      <div class="ULStepperTabs">
        <div class="ULStepperTabs__tab--list">
          <div class="">
            <ol class="list-items">
              <li class="list-item" :class="[activeTab === tab.id ? 'active':'', successTabs.includes(tab.id) ? 'success':'' ]" v-for="tab in tabNames" :key="tab.id">
                <span :class="{ 'cursor-pointer': $route.params && $route.params.id && tab.id <= activeTab }" @click="$route.params && $route.params.id && tab.id <= activeTab ? itemClick(tab) : ''">{{ tab.id }}. {{ tab.itemName }}</span>
              </li>
            </ol>
          </div>
          <router-view :roleInfo="roleInfo" :activeTab="activeTab" :nextBtn="nextBtn" :finalReview="true" :registrationId="registrationId" @submit="submit" @cancelAdd="cancelAdd" @selectedRegistrationType="selectedRegistrationType" @disableSaveBtn="disableSaveBtn" @disableDraftBtn="disableDraftBtn" @hideDraftBtn="hideDraftBtn" :componentType=" { 'type': 'view-record', 'status': '' }" ></router-view>
        </div>
    </div>
    </div>
    <div class="certificate-footer d-flex p-24">
      <div class="col-xs-12 p-0 d-flex justify-content-start col-gap-16 footer-btns">
        <button
          type="button"
          class="btn emergo-btn emergo-cancel-button"
          @click="navigateBack"
          :disabled="successTabs.length === 0"
          v-if="activeTab !== 1"
        >
          {{ $t('back') }}
        </button>
      </div>
      <div class="col-xs-12 p-0 d-flex justify-content-end col-gap-16 footer-btns">
        <button
          type="button"
          class="btn emergo-btn emergo-cancel-button"
          @click="$router.push('/layout/registration')"
        >
          {{ $t('cancel') }}
        </button>
        <button
          type="button"
          class="btn emergo-btn emergo-secondary-button"
          v-if="showHideDraftBtn"
          :disabled="disableDraft"
          @click="navigateDraft"
        >
          {{ $t('saveAsDraft') }}
        </button>
        <button
          type="button"
          class="btn emergo-btn emergo-primary-button"
          @click="navigateNext"
          v-if="[2,3].includes(activeTab)"
          :disabled="disableSave"
        >
          {{ $t('next') }}
        </button>
        <button
          type="button"
          class="btn emergo-btn emergo-primary-button"
          @click="navigateNext"
          v-if="activeTab === 1"
          :disabled="disableSave"
        >
          {{ $t('saveAndContinue') }}
        </button>
        <button
          type="button"
          class="btn emergo-btn emergo-primary-button"
          @click="navigateNext"
          v-if="activeTab === 4"
          :disabled="this.successTabs.length === this.tabNames.length"
        >
          {{ $t('finish') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    roleInfo: Object
  },
  data() {
    return {
      tabNames: [
        {
          id: 1, itemName: 'Add New Certificate Details', value: 'add', path: '/layout/registration/flow/add-record'
        },
        {
          id: 2, itemName: 'Regulation Guidance', value: 'regulation', path: '/layout/registration/flow/regulation-check'
        },
        {
          id: 3, itemName: 'Provide Evidence', value: 'evidence', path: '/layout/registration/flow/provide-evidence'
        },
        {
          id: 4, itemName: 'Final Review', value: 'final', path: '/layout/registration/flow/final-review'
        }],
      activeTab: 1,
      successTabs: [],
      nextBtn: '',
      disableSave: false,
      disableDraft: true,
      showHideDraftBtn: true,
      registrationId: '',
      registrationType: ''
    };
  },
  created() {
    const portugueseTabNames = ['Adicionar novos detalhes do certificado', 'Orientação Regulamentar', 'Fornecer evidências', 'Revisão final'];
    const englishTabNames = ['Add New Certificate Details', 'Regulation Guidance', 'Provide Evidence', 'Final Review'];
    this.tabNames.forEach((tabItem) => {
      if (localStorage.getItem('language') === 'Portuguese') {
        tabItem.itemName = portugueseTabNames[tabItem.id - 1];
      } else if (localStorage.getItem('language') === 'English') {
        tabItem.itemName = englishTabNames[tabItem.id - 1];
      }
    });
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.registrationId = this.$route.params.id;
      this.showHideDraftBtn = false;
    }
    if (this.tabNames.find((tab) => this.$route.path.includes(tab.path))) {
      this.activeTab = this.tabNames.find((tab) => this.$route.path.includes(tab.path)).id;
      const success = this.tabNames.filter((tab) => tab.id < this.activeTab);
      this.successTabs = success.map((tab) => tab.id);
    }
  },
  watch: {
    $route() {
      if (this.$route.params && this.$route.params.id) {
        this.registrationId = JSON.parse(this.$route.params.id);
      }
    },
  },
  methods: {
    itemClick(item) {
      this.activeTab = item.id;
      this.registrationType = localStorage.getItem('registrationType');
      this.successTabs = this.tabNames.filter((tab) => tab.id < this.activeTab).map((tab) => tab.id);
      this.nextBtn = '';
      const type = true;
      if (this.activeTab === 2) this.$router.push(`${this.tabNames.find((tab) => tab.id === this.activeTab).path}/${this.registrationType}/${this.registrationId}`);
      else if (this.activeTab === 1) this.$router.push({ path: `/layout/registration/flow/add-record/${this.registrationId}`, query: { type } });
      else this.$router.push(`${this.tabNames.find((tab) => tab.id === this.activeTab).path}/${this.registrationId}`);
    },
    navigateBack() {
      if (this.activeTab > 1) {
        this.activeTab -= 1;
        this.successTabs.pop();
        this.registrationType = localStorage.getItem('registrationType');
        this.nextBtn = '';
        const type = true;
        if (this.activeTab === 2) this.$router.push(`${this.tabNames.find((tab) => tab.id === this.activeTab).path}/${this.registrationType}/${this.registrationId}`);
        else if (this.activeTab === 1) this.$router.push({ path: `/layout/registration/flow/add-record/${this.registrationId}`, query: { type } });
        else this.$router.push(`${this.tabNames.find((tab) => tab.id === this.activeTab).path}/${this.registrationId}`);
      }
    },
    navigateDraft() {
      this.nextBtn = 'draft';
    },
    navigateNext() {
      this.nextBtn = this.tabNames.find((tab) => tab.id === this.activeTab).value;
    },
    disableDraftBtn(value) {
      this.disableDraft = value;
    },
    disableSaveBtn(value) {
      this.disableSave = value;
    },
    hideDraftBtn(value) {
      this.showHideDraftBtn = value;
    },
    cancelAdd() {
      this.nextBtn = '';
    },
    selectedRegistrationType(type) {
      this.registrationType = type;
    },
    submit() {
      if (this.activeTab >= 1 && this.activeTab <= this.tabNames.length) {
        this.showHideDraftBtn = false;
        this.successTabs.push(this.activeTab);
        this.activeTab += 1;
      }
    }
  },
};
</script>

<style scoped>

.primary-default-text-color {
    color: #3E3E3E;
  }

.header-top {
  border-bottom: 1px solid #B3B3B3;
  background: #EBEBEB;
}
.list-items {
  display: flex;
  justify-content: space-around;
  list-style: none;
  margin-bottom: unset;
  padding-top: 40px;
  padding-inline-start: 40px !important;
  padding-right: 40px;
}

.list-item {
  border-top: 4px solid #e6e6e6;
  padding-left: 20px;
  padding-right: 20px;
  color: #000;
  /* max-width: 322px; */
  /* height: 33px; */
  padding-top: 6px;
  width: 100%;
  margin: 0 2px;
  text-align: center;
}

.list-item.active {
  border-top: 4px solid #00518A;
}

.list-item.success {
  border-top: 4px solid #146600;
  color: #146600;
}
.certificate-content {
  background: #F5F5F5;
}
.certificate-heading {
  text-decoration: none;
  line-height: 34px;
  font-size: 24px;
  padding-left: 12px;
}

.certificate-footer {
  border-top: 1px solid #B3B3B3;

}
</style>
